import { connect } from "react-redux";
import "./App.css";

import { useEffect } from "react";
import * as actions from "./store/actions/api/auth";
import BaseRouter from "./router";
import { UserProviderContext } from "./context/UserContext";

function App(props) {
  const { onTryAutoSignup, isAuthenticated } = props;

  useEffect(() => {
    onTryAutoSignup();
  }, [onTryAutoSignup]);

  return (
    <UserProviderContext isAuthenticated={isAuthenticated}>
      <div className="App">
        <BaseRouter {...props} />
      </div>
    </UserProviderContext>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.tk !== null,
    token: state.auth.tk,
    userDetails: state.auth.userDetails,
    authChecked: state.auth.authChecked,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignup: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
